import React, { Component, Fragment } from "react";
import StaticFilter from "./staticFilter";
import Filter from "./filter";

class FiltersBar extends Component {
  getIfTheresFilters = () => {
    const facetCount = this.props.facetsNameMap.map((f) => {
      if (this.props.facets[f.field][0].data.length > 0) {
        return true;
      }
    });
    return false;
  };

  render() {
    return (
      <Fragment>
        {this.props.recordCount > 0 &&
          this.getIfTheresFilters(this.props.facets) && (
            <div className="search-filters-title">Refine Search By</div>
          )}
        {this.props.recordCount > 0 &&
          this.props.staticFacetsMap &&
          this.props.staticFacetsMap.map((f) => (
            <StaticFilter
              key={f.displayName}
              field={f.field}
              displayName={f.displayName}
              values={f.values}
              facets={this.props.facets[f.field]}
              addFacet={this.props.addFacet}
              delFacet={this.props.delFacet}
              isFacetActive={this.props.isFacetActive}
            />
          ))}
        {this.props.facetsNameMap &&
          this.props.facetsNameMap.map((f) => (
            <Filter
              app={this.props.app}
              key={f.displayName}
              field={f.field}
              displayName={f.displayName}
              facets={this.props.facets[f.field][0]}
              addFacet={this.props.addFacet}
              delFacet={this.props.delFacet}
              isFacetActive={this.props.isFacetActive}
            />
          ))}
      </Fragment>
    );
  }
}

export default FiltersBar;
